import api from "@/lib/api";

// Profili "accredito leggero" salvati nel browser (Press: nome/testata/email · Ambassador: nome/instagram/email)
export const PROFILE_KEYS = { press: "brema_press_accredited", ambassador: "brema_amb_accredited" };

export function getLoungeProfile(area) {
  try { return JSON.parse(localStorage.getItem(PROFILE_KEYS[area] || PROFILE_KEYS.press) || "null"); } catch { return null; }
}

export function saveLoungeProfile(area, profile) {
  try { localStorage.setItem(PROFILE_KEYS[area] || PROFILE_KEYS.press, JSON.stringify({ ...profile, at: Date.now() })); } catch { /* ignore */ }
}

export function loungeSessionId() {
  try {
    let s = sessionStorage.getItem("brema_lounge_session");
    if (!s) { s = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`; sessionStorage.setItem("brema_lounge_session", s); }
    return s;
  } catch { return ""; }
}

// Registra download / consultazioni / accessi (fire-and-forget)
export function trackLoungeEvent({ area = "press", type = "download", item = {}, lang = "" }) {
  const profile = getLoungeProfile(area) || {};
  let ref = "";
  try { ref = sessionStorage.getItem("lounge_ref") || ""; } catch { /* ignore */ }
  const payload = {
    area, type, item,
    profile: { name: profile.name || "", email: profile.email || "", outlet: profile.outlet || "", social: profile.social || "" },
    session_id: loungeSessionId(), ref, lang,
  };
  return api.post("/public/lounge/event", payload).catch(() => {});
}

// Accesso Ambassador: una volta per sessione, solo se accreditato
export function trackLoungeAccessOnce(area, lang) {
  const profile = getLoungeProfile(area);
  if (!profile?.email) return;
  const key = `brema_lounge_access_${area}`;
  try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, "1"); } catch { /* ignore */ }
  trackLoungeEvent({ area, type: "access", item: { kind: "page", title: area === "ambassador" ? "Ambassador Lounge" : "Press Lounge" }, lang });
}
